/**
 * @fileoverview gRPC-Web generated client stub for mlmbox.client.asset.v1
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.2
// 	protoc              v3.15.8
// source: mlmbox/client/asset/v1/asset.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var mlmbox_type_asset_pb = require('../../../../mlmbox/type/asset_pb.js')

var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js')
const proto = {};
proto.mlmbox = {};
proto.mlmbox.client = {};
proto.mlmbox.client.asset = {};
proto.mlmbox.client.asset.v1 = require('./asset_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.mlmbox.client.asset.v1.AssetClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.mlmbox.client.asset.v1.AssetPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.mlmbox.type.Asset.ID,
 *   !proto.mlmbox.type.Asset>}
 */
const methodDescriptor_Asset_Get = new grpc.web.MethodDescriptor(
  '/mlmbox.client.asset.v1.Asset/Get',
  grpc.web.MethodType.UNARY,
  mlmbox_type_asset_pb.Asset.ID,
  mlmbox_type_asset_pb.Asset,
  /**
   * @param {!proto.mlmbox.type.Asset.ID} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  mlmbox_type_asset_pb.Asset.deserializeBinary
);


/**
 * @param {!proto.mlmbox.type.Asset.ID} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.mlmbox.type.Asset)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.mlmbox.type.Asset>|undefined}
 *     The XHR Node Readable Stream
 */
proto.mlmbox.client.asset.v1.AssetClient.prototype.get =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/mlmbox.client.asset.v1.Asset/Get',
      request,
      metadata || {},
      methodDescriptor_Asset_Get,
      callback);
};


/**
 * @param {!proto.mlmbox.type.Asset.ID} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.mlmbox.type.Asset>}
 *     Promise that resolves to the response
 */
proto.mlmbox.client.asset.v1.AssetPromiseClient.prototype.get =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/mlmbox.client.asset.v1.Asset/Get',
      request,
      metadata || {},
      methodDescriptor_Asset_Get);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.mlmbox.type.Asset>}
 */
const methodDescriptor_Asset_All = new grpc.web.MethodDescriptor(
  '/mlmbox.client.asset.v1.Asset/All',
  grpc.web.MethodType.SERVER_STREAMING,
  google_protobuf_empty_pb.Empty,
  mlmbox_type_asset_pb.Asset,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  mlmbox_type_asset_pb.Asset.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.mlmbox.type.Asset>}
 *     The XHR Node Readable Stream
 */
proto.mlmbox.client.asset.v1.AssetClient.prototype.all =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/mlmbox.client.asset.v1.Asset/All',
      request,
      metadata || {},
      methodDescriptor_Asset_All);
};


/**
 * @param {!proto.google.protobuf.Empty} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.mlmbox.type.Asset>}
 *     The XHR Node Readable Stream
 */
proto.mlmbox.client.asset.v1.AssetPromiseClient.prototype.all =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/mlmbox.client.asset.v1.Asset/All',
      request,
      metadata || {},
      methodDescriptor_Asset_All);
};


module.exports = proto.mlmbox.client.asset.v1;

